import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string, outlined?: boolean }>`
  background: ${(p) => p.outlined ? "#232328" : "#8d49fb"};
  color: ${(p) => (p.outlined ? "#8d49fb" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border-radius: 4px;
  padding: 0.4rem 1.2rem;
  max-width: fit-content;
  min-width: fit-content;
  cursor: pointer;
  margin-top: 0.625rem;
  transition: all 0.3s ease-in-out;
  border: 1px solid rgba(255, 255, 255, 0);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid #ac7cf8ff;
    background-color: #ac7cf8ff;
  }
`;

export const ButtonContent = styled("div")`
  display: flex;
  justify-content: center;
`;
